<span class="loading-indicator">
  <span class="loading-indicator__dot loading-indicator__dot--first"></span>
  <span class="loading-indicator__dot loading-indicator__dot--second"></span>
  <span class="loading-indicator__dot loading-indicator__dot--third"></span>
</span>
